export default __webpack_public_path__ + "static/media/boston-children-logo.f393621d.png";